export default "__VITE_ASSET__CwYrQLn5__"